import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

type CallbackEmitter = (value: boolean) => void;

const Emitter = {
  on: (event: string, fn: CallbackEmitter) => eventEmitter.on(event, fn),
  once: (event: string, fn: CallbackEmitter) => eventEmitter.once(event, fn),
  off: (event: string, fn: CallbackEmitter) => eventEmitter.off(event, fn),
  emit: (event: string, payload: boolean) => eventEmitter.emit(event, payload),
};

Object.freeze(Emitter);

export default Emitter;
